export default __webpack_public_path__ + "static/media/Blessed Do Kki.73a637fd.jpg";